var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemValidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    rx: 3,
    fill: "#F9B609"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22699 13H12.7859C12.9854 12.9986 13.1815 12.9474 13.3571 12.8508C13.5328 12.7543 13.6826 12.6154 13.7935 12.4462C13.9044 12.2771 13.9731 12.0828 13.9936 11.8803C14.014 11.6778 13.9856 11.4733 13.9108 11.2847L9.57018 3.64357C9.46445 3.44858 9.30945 3.28605 9.1213 3.17287C8.93316 3.05969 8.71873 3 8.50032 3C8.28191 3 8.06749 3.05969 7.87934 3.17287C7.6912 3.28605 7.5362 3.44858 7.43046 3.64357L3.08988 11.2847C3.01649 11.469 2.98738 11.6686 3.005 11.8668C3.02262 12.065 3.08644 12.256 3.19116 12.4239C3.29587 12.5918 3.43842 12.7317 3.60692 12.8319C3.77542 12.9321 3.96497 12.9898 4.15974 13",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.5V8M8.5 10.9937V11",
    stroke: "#F9B609",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemValidity);
export default __webpack_public_path__ + "static/media/item-validity.6f08444cef45062f89d49be6af2aa86b.svg";
export { ForwardRef as ReactComponent };